import {ApiClient} from './apiClient/apiClient';

const apiClient = new ApiClient();

export const getInvoices = (params) => {
    return apiClient.get("invoices", params);
};

export const getInvoice = (id, userId) => {
    return apiClient.get(`invoices/${id}`, {userId});
};

export const createInvoice = (invoice) => {
    return apiClient.post('invoices/send', invoice);
};

export const updateInvoice = (invoice) => {
    return apiClient.put(`invoices/${invoice.id}`, invoice);
}

export const deleteInvoice = (id, userId) => {
    return apiClient.delete(`invoices/${id}`, {userId});
};

export const saveDraft = (invoice) => {
    return apiClient.post('invoices/draft', invoice);
}



